import { Model } from '@/models/Model';

export class Size extends Model
{
  protected $name: string = 'Size';
  protected $endpoint: string = '/sizes';
  protected $fillable: string[] = ['name', 'short_name'];

  public name?: string;
  public short_name?: string;
  public id?: string;

  protected static instance?: Size;
  public static getInstance(instance: Size) {
    if (! this.instance) {
      this.instance = instance;
    }

    return this.instance;
  }
}
